import { render, staticRenderFns } from "./ActivityConfig.vue?vue&type=template&id=e87a30b6&scoped=true&"
import script from "./ActivityConfig.vue?vue&type=script&lang=js&"
export * from "./ActivityConfig.vue?vue&type=script&lang=js&"
import style0 from "./ActivityConfig.vue?vue&type=style&index=0&id=e87a30b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87a30b6",
  null
  
)

export default component.exports